/**
 * Profile Settings Page
 * Placeholder — full implementation from original will be ported.
 */

export function ProfileSettingsPage() {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-text-primary">
        Profile Settings
      </h2>
      <div className="rounded-lg border border-border-default bg-bg-secondary p-6">
        <p className="text-text-secondary">
          Profile settings form will be displayed here.
        </p>
      </div>
    </div>
  );
}
